import * as types from './types';

const tourFinished = ({ commit }, tourName) => {
  commit(types.TOUR_FINISHED, tourName);
};

const allToursFinished = ({ commit }) => {
  commit(types.ALL_TOURS_FINISHED);
};

const getTourState = ({ commit }, tourName) => {
  commit(types.GET_TOUR_STATE, tourName);
};

const clearTourStates = ({ commit }, tourName) => {
  commit(types.CLEAR_TOUR_STATES, tourName);
};

export const actions = {
  [types.TOUR_FINISHED]: tourFinished,
  [types.ALL_TOURS_FINISHED]: allToursFinished,
  [types.GET_TOUR_STATE]: getTourState,
  [types.CLEAR_TOUR_STATES]: clearTourStates,
};
